import { useMutation } from '@apollo/client';
import { useCallback } from 'react';
import { ENTREGADOR_ALTERAR_POSSUI_BAU } from 'gql/entregador';

export const useTogglePossuiBau = () => {
    const [togglePossuiBau, { loading: loadingTogglePossuiBau }] = useMutation(
        ENTREGADOR_ALTERAR_POSSUI_BAU
    );
    const handleTogglePossuiBau = useCallback(
        ({ entregadorId, possuiBau } : {
            entregadorId: string;
            possuiBau: boolean;
        }) => {
            console.log('id', entregadorId, possuiBau);
            togglePossuiBau({
                variables: { entregadorId, possuiBau },
            });
        },
        [togglePossuiBau]
    );
    return {
        handleTogglePossuiBau,
        loadingTogglePossuiBau,
    };
};